import { rem } from './rem';

interface Token {
    fontFamily: string;
    fontWeight: number;
    lineHeight: number;
    fontSize: number;
    letterSpacing?: number | string;
}

export const getTypographyTokens = (token: Token) => `
    font-family: ${token.fontFamily};
    font-size: ${rem({ size: token.fontSize })};
    font-weight: ${token.fontWeight};
    line-height: ${token.lineHeight};
    ${token.letterSpacing && `letter-spacing: ${token.letterSpacing};`};
`;
